import type { NavItem, Testimonial } from './types';

/** Canonical company/contact details. Single source of truth — footer, contact page, schema.org. */
export const company = {
  name: 'AniMon Infotech Solutions',
  shortName: 'AniMon',
  legalName: 'Ani-Mon Infotech Solution',
  tagline: 'sustained endeavour',
  blurb:
    'Ani-Mon Infotech Solution (hereafter referred to as AniMon) is a black empowered company registered in South Africa. The company was incorporated as a Close Corporation in 2007.',
  address: {
    street: '10 Tainton St., De Wetshof Ext.1',
    postal: 'PO BOX 546, Bruma 2026',
    city: 'Johannesburg',
    country: 'South Africa',
    full: '10 Tainton St., De Wetshof Ext.1, 2198 PO BOX 546, Bruma 2026',
    /** Uses the address text, not raw coordinates, so the destination is labelled
     *  "10 Tainton St" (not an anonymous pin) when the link opens — verified live
     *  (see contact-locator.md's Status note). The equivalent geocoded coordinate,
     *  -26.1818916, 28.0986548, was cross-checked against Google's own resolution
     *  for "Tainton St" and confirmed to land on the real street; the doc's
     *  originally-specified -26.1783, 28.1103 was ~1.3km off, near Eastgate Mall. */
    mapsHref:
      'https://www.google.com/maps/search/?api=1&query=10+Tainton+St+De+Wetshof+Ext+1+Bruma+2026+Johannesburg',
  },
  email: 'info@animonis.co.za',
  phones: [{ label: '+27-83-222-1884', href: 'tel:+27832221884' }],
  /** Primary number used in the "Talk To Us" CTA on service pages. */
  primaryPhone: { label: '+27-83-222-1884', href: 'tel:+27832221884' },
  social: [
    { label: 'Facebook', href: 'https://m.facebook.com/100069255225216/' },
    { label: 'Instagram', href: 'https://www.instagram.com/animon_infotech_solutions/' },
    { label: 'X', href: 'https://twitter.com/AniMonInfotechS' },
  ],
} as const;

export const nav: readonly NavItem[] = [
  { label: 'Home', href: '/' },
  {
    label: 'Services',
    href: '/services',
    children: [
      { label: 'Business Intelligence', href: '/services/business-intelligence' },
      { label: 'Data Science', href: '/services/data-science' },
      { label: 'AI & ML', href: '/services/ai-ml' },
      { label: 'Business Process Management', href: '/services/business-process-management' },
      { label: 'Website Development', href: '/services/website-development' },
      { label: 'App Development', href: '/services/app-development' },
      { label: 'Digital Marketing', href: '/services/digital-marketing' },
    ],
  },
  {
    label: 'Products',
    href: '/products',
    children: [
      { label: 'SmartFace', href: '/products/smartface' },
      { label: 'SmartCourier', href: '/products/smartcourier' },
    ],
  },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const testimonials: readonly Testimonial[] = [
  {
    quote:
      'AniMon Infotech staff listened to our requirements and resulting in an outcome that exceeded our expectations.',
    name: 'Sarah T.',
    role: 'Business Owner',
    rating: 5,
  },
  {
    quote:
      "I've worked with a lot of companies, from communication to entire process, AniMon Infotech is the best in the business.",
    name: 'James L.',
    role: 'Business Owner',
    rating: 5,
  },
];

/** Reused CTA band — appears on Home, Services hub, and About in the source site. */
export const ctaBand = {
  heading: 'Jump into the Thrill of Your Project',
  body: 'With our professional guidance, embark on your visionary journey, transforming ideas into significant reality.',
  primary: { label: 'Get started', href: '/contact' },
  secondary: { label: 'Learn more', href: '/services' },
} as const;
